import React, {FC} from 'react';

import {TEntityValue} from 'modules/data';

import {STATUS_TITLES} from './factor-influence-status-cell.consts';

interface IFactorInfluenceStatusProps {
    value?: TEntityValue;
}

export const FactorInfluenceStatus: FC<IFactorInfluenceStatusProps> = ({value}: IFactorInfluenceStatusProps) => {
    const statusCode = String(value || '');
    const title = STATUS_TITLES[statusCode] || statusCode;

    return <span>{title}</span>;
};
